(() => {
  if (window.__fpMatchdayBoot) return;
  window.__fpMatchdayBoot = true;
  const mobile = window.matchMedia('(max-width: 749px)');
  const controllers = new WeakMap();
  function init(root) {
    if (!mobile.matches || controllers.has(root)) return;
    const controller = new AbortController();
    controllers.set(root, controller);
    const on = (node, name, cb) => node?.addEventListener(name, cb, {signal: controller.signal});
    const tabs = [...root.querySelectorAll('[data-md-tab]')];
    const panels = [...root.querySelectorAll('[data-md-panel]')];
    function select(name) {
      tabs.forEach(tab => tab.setAttribute('aria-pressed', String(tab.dataset.mdTab === name)));
      panels.forEach(panel => { panel.hidden = panel.dataset.mdPanel !== name; });
    }
    select('clubs');
    tabs.forEach(tab => on(tab, 'click', () => select(tab.dataset.mdTab)));
    const dialog = root.querySelector('.md-menu');
    on(root.querySelector('[data-md-menu]'), 'click', () => dialog.showModal());
    on(root.querySelector('[data-md-close]'), 'click', () => dialog.close());
    on(dialog, 'click', event => {
      const box = dialog.getBoundingClientRect();
      if(event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
    });
    on(root.querySelector('[data-md-search]'), 'click', event => {
      event.preventDefault();
      const input = root.querySelector('.md-search input[type=search]');
      input.scrollIntoView({block: 'center', behavior: 'auto'});
      input.focus({preventScroll: true});
    });
    root.querySelectorAll('[data-md-bag]').forEach(link => on(link, 'click', event => {
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if(trigger instanceof HTMLElement) {event.preventDefault();trigger.click();}
      // Native cart URL remains the fallback; no cart or checkout mutation.
    }));
    on(document, 'cart:update', event => {
      const count = event.detail?.data?.item_count ?? event.detail?.resource?.item_count;
      if(Number.isInteger(count)) root.querySelectorAll('[data-md-cart-count]').forEach(el => {el.textContent=String(count);el.hidden=count===0;});
    });
    on(root.querySelector('[data-md-copy]'), 'click', async event => {
      const button = event.currentTarget;
      const code = root.querySelector('[data-md-code]').textContent.trim();
      const status = root.querySelector('[data-md-copy-status]');
      let copied = false;
      try {await navigator.clipboard.writeText(code);copied=true;} catch {
        const textarea = document.createElement('textarea');
        textarea.value=code;textarea.setAttribute('readonly','');textarea.style.cssText='position:fixed;left:-9999px;top:0';
        root.append(textarea);textarea.select();
        try {copied=document.execCommand('copy');} catch {} finally {textarea.remove();button.focus();}
      }
      button.textContent=copied?'Copied!':'Copy code';
      status.textContent=copied?'Discount code copied.':`Copy this code manually: ${code}`;
    });
    const bindTeamImage = img => on(img, 'error', () => {
      img.hidden=true;
      const placeholder=document.createElement('span');placeholder.className='md-team__placeholder';placeholder.textContent='⚽';placeholder.setAttribute('aria-hidden','true');
      if(!img.parentElement.querySelector('.md-team__placeholder'))img.parentElement.append(placeholder);
    });
    root.querySelectorAll('.md-team__image img').forEach(bindTeamImage);
    const hydrateDetails = details => {
      if (!details.open) return;
      const template = details.querySelector(':scope > template[data-md-deferred-template]');
      if (!(template instanceof HTMLTemplateElement)) return;
      const fragment = template.content.cloneNode(true);
      const images = [...fragment.querySelectorAll('.md-team__image img')];
      template.replaceWith(fragment);
      images.forEach(bindTeamImage);
    };
    root.querySelectorAll('details[data-md-deferred]').forEach(details => {
      on(details, 'toggle', () => hydrateDetails(details));
      hydrateDetails(details);
    });
    // Codex: mobile predictive search 2026-09-19
    const searchForm = root.querySelector('[data-md-search-form]');
    const searchInput = root.querySelector('[data-md-search-input]');
    const searchPanel = root.querySelector('[data-md-predictive]');
    if (searchForm && searchInput && searchPanel) {
      const predictiveUrl = searchForm.dataset.mdPredictiveUrl;
      const currency = searchForm.dataset.mdCurrency || 'USD';
      const aliases = new Map([
        ['cr7', 'cristiano ronaldo'],
        ['r9', 'ronaldo nazario'],
        ['manu', 'manchester united'],
        ['man u', 'manchester united'],
        ['man utd', 'manchester united'],
        ['man united', 'manchester united'],
        ['barca', 'barcelona'],
        ['vini', 'vini jr'],
        ['spurs', 'tottenham hotspur'],
        ['psg', 'paris saint germain'],
        ['bayern', 'bayern munich']
      ]);
      let searchTimer;
      let searchRequest;
      let lastRenderedQuery = '';
      const normalizeSearch = value => {
        const clean = value.trim().replace(/\s+/g, ' ');
        return aliases.get(clean.toLowerCase()) || clean;
      };
      const setSearchOpen = open => {
        searchPanel.hidden = !open;
        searchInput.setAttribute('aria-expanded', String(open));
      };
      const closeSearch = () => setSearchOpen(false);
      const searchLinks = () => [...searchPanel.querySelectorAll('a[href]')];
      const addHeading = text => {
        const heading = document.createElement('p');
        heading.className = 'md-predictive__heading';
        heading.textContent = text;
        searchPanel.append(heading);
      };
      const formatPrice = value => {
        const amount = Number(value);
        if (!Number.isFinite(amount)) return '';
        try { return new Intl.NumberFormat(undefined, {style: 'currency', currency}).format(amount); }
        catch { return '$' + amount.toFixed(2); }
      };
      const productImageUrl = value => {
        if (!value) return '';
        try { const url = new URL(value, location.origin); url.searchParams.set('width', '120'); return url.href; }
        catch { return value; }
      };
      const renderSearch = (results, displayQuery, requestQuery) => {
        if (searchInput.value.trim() !== displayQuery) return;
        searchPanel.replaceChildren();
        const collections = Array.isArray(results.collections) ? results.collections : [];
        const products = Array.isArray(results.products) ? results.products : [];
        if (!collections.length && !products.length) {
          const empty = document.createElement('p');
          empty.className = 'md-predictive__status';
          empty.textContent = 'No matches yet. Try a player, club or country.';
          searchPanel.append(empty);
          setSearchOpen(true);
          lastRenderedQuery = displayQuery;
          return;
        }
        if (collections.length) {
          addHeading('Players & teams');
          collections.forEach(collection => {
            const link = document.createElement('a');
            link.className = 'md-predictive__collection';
            link.href = collection.url;
            const title = document.createElement('span');
            title.textContent = collection.title;
            const type = document.createElement('small');
            type.textContent = 'Collection';
            link.append(title, type);
            searchPanel.append(link);
          });
        }
        if (products.length) {
          addHeading('Products');
          products.forEach(product => {
            const link = document.createElement('a');
            link.className = 'md-predictive__product';
            link.href = product.url;
            const media = document.createElement('span');
            media.className = 'md-predictive__image';
            const imageUrl = productImageUrl(product.featured_image?.url || product.image);
            if (imageUrl) {
              const image = document.createElement('img');
              image.src = imageUrl;
              image.alt = '';
              image.width = 56;
              image.height = 70;
              image.loading = 'lazy';
              image.decoding = 'async';
              media.append(image);
            }
            const copy = document.createElement('span');
            copy.className = 'md-predictive__copy';
            const title = document.createElement('span');
            title.className = 'md-predictive__title';
            title.textContent = product.title;
            const price = document.createElement('strong');
            price.className = 'md-predictive__price';
            price.textContent = formatPrice(product.price_min || product.price);
            copy.append(title, price);
            link.append(media, copy);
            searchPanel.append(link);
          });
        }
        const all = document.createElement('a');
        all.className = 'md-predictive__all';
        all.href = searchForm.action + '?q=' + encodeURIComponent(requestQuery) + '&type=product';
        all.textContent = 'View all results';
        searchPanel.append(all);
        setSearchOpen(true);
        lastRenderedQuery = displayQuery;
      };
      const runSearch = async value => {
        const displayQuery = value.trim();
        if (displayQuery.length < 2) { closeSearch(); return; }
        const requestQuery = normalizeSearch(displayQuery);
        searchRequest?.abort();
        searchRequest = new AbortController();
        const loading = document.createElement('p');
        loading.className = 'md-predictive__status';
        loading.textContent = 'Searching…';
        searchPanel.replaceChildren(loading);
        setSearchOpen(true);
        try {
          const url = new URL(predictiveUrl, location.origin);
          url.searchParams.set('q', requestQuery);
          url.searchParams.set('resources[type]', 'product,collection');
          url.searchParams.set('resources[limit]', '5');
          url.searchParams.set('resources[options][unavailable_products]', 'hide');
          const response = await fetch(url, {headers: {Accept: 'application/json'}, signal: searchRequest.signal});
          if (!response.ok) throw new Error('Search request failed');
          const data = await response.json();
          renderSearch(data.resources?.results || {}, displayQuery, requestQuery);
        } catch (error) {
          if (error.name === 'AbortError') return;
          const unavailable = document.createElement('p');
          unavailable.className = 'md-predictive__status';
          unavailable.textContent = 'Search is temporarily unavailable. Press Search to continue.';
          searchPanel.replaceChildren(unavailable);
          setSearchOpen(true);
        }
      };
      on(searchInput, 'input', () => {
        clearTimeout(searchTimer);
        const value = searchInput.value;
        if (value.trim().length < 2) { searchRequest?.abort(); closeSearch(); return; }
        searchTimer = setTimeout(() => runSearch(value), 220);
      });
      on(searchInput, 'focus', () => {
        if (searchInput.value.trim() === lastRenderedQuery && searchPanel.childElementCount) setSearchOpen(true);
      });
      on(searchInput, 'keydown', event => {
        if (event.key === 'Escape') { closeSearch(); return; }
        if (event.key === 'ArrowDown' && !searchPanel.hidden) {
          const first = searchLinks()[0];
          if (first) { event.preventDefault(); first.focus(); }
        }
      });
      on(searchPanel, 'keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); searchInput.focus(); closeSearch(); return; }
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
        const links = searchLinks();
        const index = links.indexOf(document.activeElement);
        if (index < 0) return;
        event.preventDefault();
        if (event.key === 'ArrowUp' && index === 0) { searchInput.focus(); return; }
        links[(index + (event.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      });
      on(document, 'click', event => {
        if (!searchForm.contains(event.target)) closeSearch();
      });
      on(searchForm, 'submit', () => { clearTimeout(searchTimer); searchRequest?.abort(); });
      controller.signal.addEventListener('abort', () => { clearTimeout(searchTimer); searchRequest?.abort(); }, {once: true});
    }
    root.dataset.mdReady='true';
  }
  const boot=()=>document.querySelectorAll('[data-matchday-home]').forEach(init);
  mobile.addEventListener('change', () => {
    document.querySelectorAll('[data-matchday-home]').forEach(root => {
      if(!mobile.matches){controllers.get(root)?.abort();controllers.delete(root);root.querySelector('dialog[open]')?.close();delete root.dataset.mdReady;}
    });boot();
  });
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', event => {event.target.querySelectorAll('[data-matchday-home]').forEach(root=>{controllers.get(root)?.abort();controllers.delete(root);});});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
